import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Installer} from '../../../model/Installer';

@Component({
  selector: 'app-view-observation-cancel',
  templateUrl: './view-description.component.html',
  styleUrls: ['./view-description.component.css']
})
export class ViewDescriptionComponent implements OnInit {

  public installer: Installer;
  public description: any;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    this.description = this.installer.description;
  }

  public accept() {
    this.activeModal.close();
  }
}
